import { client } from '../lib/client';
// 로그인 정보 me
export const meAPI = () => (
  client({
    url: '/v1/me',
  }, true)
);

export const snsJoinAPI = (data) => (
  client({
    url: '/v1/join/sns',
    method: 'post',
    data
  })
);

export const snsLoginAPI = (data) => (
  client({
    url: '/v1/login/sns',
    method: 'post',
    data
  })
);

// 이메일 가입 — 기업회원이 사업자등록증(file)을 첨부하면 multipart(bizCert) 로 보낸다
export const emailJoinAPI = (data, file) => {
  if (!file) return client({ url: '/v1/join/email', method: 'post', data });
  const fd = new FormData();
  Object.keys(data).forEach((k) => { if (data[k] !== undefined && data[k] !== null) fd.append(k, data[k]); });
  fd.append('bizCert', file);
  return client({ url: '/v1/join/email', method: 'post', data: fd, file: true });
};

export const emailLoginAPI = (data) => (
  client({
    url: '/v1/login/email',
    method: 'post',
    data
  })
);

// 아이디 찾기
export const findIdAPI = (data) => (
  client({
    url: '/v1/find/id',
    method: 'post',
    data
  })
);

// 비밀번호 찾기
export const findPwdAPI = (data) => (
  client({
    url: '/v1/find/pwd',
    method: 'post',
    data
  })
);

// 비밀번호 변경
export const changePwdAPI = (data) => (
  client({
    url: '/v1/find/pwd',
    method: 'put',
    data
  })
);

// 회원탈퇴
export const leaveAPI = (params) => (
  client({
    url: '/v1/quit',
    method: 'put',
    data: params
  }, true)
);

// 휴대폰 인증번호 발송 — 팝빌 SMS (가입·아이디/비밀번호 찾기·번호 변경)
export const smsSendAPI = (data) => (
  client({
    url: '/v1/auth/sms/send',
    method: 'post',
    data
  })
);

// 휴대폰 인증번호 확인 → { uid } — 가입·찾기 요청에 uid 로 넣는다
export const smsVerifyAPI = (data) => (
  client({
    url: '/v1/auth/sms/verify',
    method: 'post',
    data
  })
);

// 비밀번호 확인 — 탈퇴 1단계(이메일 회원). 소셜 회원은 required:false 로 바로 통과
export const verifyPasswordAPI = (data) => (
  client({
    url: '/v1/user/password/verify',
    method: 'post',
    data
  }, true)
);

// 법인카드 등록/삭제(기업회원) — 서버는 끝 4자리만 보관한다
export const cardSaveAPI = (data) => (
  client({ url: '/v1/user/card', method: 'put', data }, true)
);
export const cardDeleteAPI = () => (
  client({ url: '/v1/user/card', method: 'delete' }, true)
);

// 마일리지 잔액·원장
export const mileageAPI = () => (
  client({ url: '/v1/user/mileage' }, true)
);

// 비밀번호 변경(로그인 상태) — 현재 비밀번호 + 새 비밀번호
export const passwordChangeAPI = (data) => (
  client({
    url: '/v1/user/password',
    method: 'put',
    data
  }, true)
);

// 의뢰자 정보 설정 — 마이페이지 모달(상호·부서명·주소·상세주소). 이름·연락처는 회원 정보
export const requesterSaveAPI = (data) => (
  client({
    url: '/v1/user/requester',
    method: 'put',
    data
  }, true)
);

// 핸드폰 번호 변경
export const phoneChangeAPI = (data) => (
  client({
    url: `/v1/user/phone`,
    method: 'put',
    data
  }, true)
);
